import { HemsFeaturesPresentSinceResponse } from '../../../projects/client';
import { StatusValue } from '../app.state.models';
import { DeviceWithAvailableFeatures } from './analytics.model';

export interface AnalyticsState {
  devicesWithAvailableFeatures: StatusValue<DeviceWithAvailableFeatures>;
  hemsFeaturesPresentSince: StatusValue<HemsFeaturesPresentSinceResponse>;
}

export const initAnalyticsState: AnalyticsState = {
  devicesWithAvailableFeatures: {
    loading: false,
    error: null,
    value: null,
  },
  hemsFeaturesPresentSince: {
    loading: false,
    error: null,
    value: null,
  },
};
